import axios from 'axios'
import barramento from "@/barramento"

const success = res => res
const error = err => {
    if (401 === err.response.status) {
        barramento.enviarStatusLogin(true, true)
    } else {
        return Promise.reject(err)
    }
}

axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['Pragma'] = 'no-cache';
axios.defaults.headers.common['Expires'] = '0';

axios.interceptors.response.use(success, error)